import { t } from '../composables/useText.js';

const API_BASE = 'https://v3.football.api-sports.io';

const apiKey = import.meta.env.VITE_API_FOOTBALL_KEY;

const buildUrl = (path, params = {}) => {
  const url = new URL(`${API_BASE}${path}`);
  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null) {
      url.searchParams.set(key, value);
    }
  });
  return url;
};

const apiFetch = async (path, params) => {
  if (!apiKey) {
    throw new Error(t('api.missing-key'));
  }

  const response = await fetch(buildUrl(path, params), {
    headers: {
      'x-apisports-key': apiKey
    }
  });

  if (!response.ok) {
    throw new Error(`${t('api.request-failed')} (${response.status}).`);
  }

  const data = await response.json();

  if (data?.errors && Object.keys(data.errors).length > 0) {
    throw new Error(t('api.error'));
  }

  return data;
};

export const fetchPlayersPage = (leagueId, seasonYear, page = 1, teamId = '') => {
  const params = {
    season: seasonYear,
    page
  };

  if (teamId) {
    params.team = teamId;
  } else {
    params.league = leagueId;
  }

  return apiFetch('/players', params);
};

export const fetchPlayerSeasons = (playerId) => {
  return apiFetch('/players/seasons', { player: playerId });
};

export const fetchPlayerSeasonStats = (playerId, seasonYear) => {
  return apiFetch('/players', { id: playerId, season: seasonYear });
};

export const fetchTeamsByLeagueSeason = (leagueId, seasonYear) => {
  return apiFetch('/teams', { league: leagueId, season: seasonYear });
};
